import './App.css';
import Blogs from './Components/Blogs';
import Footer from './Components/Footer';
import Navigation from './Components/Navigation';
import Search from './Components/Search';

function App() {
  return (
    <div>
      <Navigation />
      <Search />
      <Blogs />
      <Footer />
    </div>
  );
}

export default App;
